// common
import React from "react";
import { Link } from "react-router-dom";

// style
import styled from "styled-components";

// const
import { quickMenuConst } from "constants/widget/quickMenuConst";
import { scrollState } from "recoils/common/commonState";
import { useRecoilValue } from "recoil";

// 위젯 퀵 메뉴로, 문의하기, 요금 계산기, 페이지 최상단 이동 기능 수행
export const QuickMenu = () => {
  const scroll = useRecoilValue(scrollState);

  return (
    <QuickMenuLayout>
      {quickMenuConst.map((menu, idx) => (
        <QuickLink
          key={menu.title + idx.toString()}
          to={menu.link}
          tooltip={menu.title}
          onClick={() => {
            if (menu.link === "#") {
              if (scroll) {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }
            }
          }}
        >
          {menu.icon}
          <QuickLinkTitle>{menu.title}</QuickLinkTitle>
        </QuickLink>
      ))}
    </QuickMenuLayout>
  );
};

const QuickMenuLayout = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const QuickLink = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: ${({ theme }) => theme.color.gray500};
  border-radius: 50%;

  &:not(:last-child) {
    background: ${({ theme }) => theme.color.primary};
  }

  svg {
    fill: ${({ theme }) => theme.color.white};
    stroke: ${({ theme }) => theme.color.white};
  }

  &:after {
    content: attr(tooltip);
    position: absolute;
    right: 55px;
    width: max-content;
    padding: 4px 12px;
    color: ${({ theme }) => theme.color.white};
    font-size: 12px;
    border-radius: 4px;
    background: ${({ theme }) => theme.color.gray30};
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  }

  &:hover {
    &:after {
      visibility: visible;
      opacity: 1;
    }
  }
`;
const QuickLinkTitle = styled.span`
  font-size: 0;
  line-height: 0;
`;
